<template>
    <div class = "Nav">
        <el-menu
            :key="componentKey"
            :class="el-menu-demo"
            :default-active="activeIndex"
            mode="horizontal"
            @select="handleSelect"
            background-color="#ffffff"
            text-color="#513890"
            active-text-color="#80309c"
            :ellipsis="true"
            @unique-opened="true"
            :close-on-click-outside="true"
            :popper-offset="16">
            <el-menu-item index="0" @click="openLink('/', '_top')">
                <img alt="NavMenu logo" src="../assets/images/navLogo.png" height="30px"/>
            </el-menu-item>
            <!-- disabled属性表示不可选中 -->
            <div class="flex-grow"></div><!-- 临时右对齐方案 -->
            <el-sub-menu index="1" @click="roll('news')">
                <template #title>新闻与活动</template>
                <el-menu-item index="1-1" @click="openLink('https://mp.weixin.qq.com/s/46wiqky-zcLWQtae04cxbA', '_blank')">2024年 F1在学校 沙特世界赛报道——荣耀时刻</el-menu-item>
                <el-menu-item index="1-2" @click="openLink('https://mp.weixin.qq.com/s/PkhO5SAWqFBytr0irgpEdw', '_blank')">第九届市西中学STEM科创体验活动暨2024年 F1在学校 国赛</el-menu-item>
                <el-menu-item index="1-3" @click="openLink('https://mp.weixin.qq.com/s/kNYW-bMOtIyaYVxg9LVX7Q', '_blank')">与学生共赴F1之旅：探索STEM的深奥世界</el-menu-item>
                <el-menu-item index="1-4" @click="newsDialogVisible01 = true">2023 F1在学校 世界总决赛</el-menu-item>
                <el-menu-item index="1-5" @click="newsDialogVisible02 = true">第十五届上海模型节日</el-menu-item>
                <el-menu-item index="1-6" @click="newsDialogVisible03 = true">联合国教科文组织女童和妇女教育奖</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="2" @click="roll('services')">
                <template #title>产品与服务</template>
                <el-sub-menu index="2-1">
                    <template #title>国际竞赛</template>
                    <el-menu-item index="2-1-1" @click="wroRobotDialogVisible = true">WRO世界机器人奥林匹克</el-menu-item>
                    <el-menu-item index="2-1-2" @click="firstRobotDialogVisible = true">FIRST机器人挑战赛</el-menu-item>
                    <el-menu-item index="2-1-3" @click="f1InSchoolsDialogVisible = true">F1在学校</el-menu-item>
                </el-sub-menu>
                <el-menu-item index="2-2" @click="switchDialogVisible = true">国际交流</el-menu-item>
                <el-menu-item index="2-3" @click="serviceDialogVisible = true">课程设计</el-menu-item>
                <el-menu-item index="2-4" @click="schoolDialogVisible = true">实验室搭建</el-menu-item>
            </el-sub-menu>
            <el-menu-item index="3" @click="roll('about')">企业简介</el-menu-item>
            <el-menu-item index="4" @click="roll('highlights')">成果展示</el-menu-item>
            <el-menu-item index="5" @click="contactDialogVisible = true">联系我们</el-menu-item>
        </el-menu>

        <el-dialog
            class="el-dialog-container"
            v-model="newsDialogVisible"
            title="新闻与活动"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <TabVue01></TabVue01>
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="newsDialogVisible01"
            title="新闻与活动"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <News01></News01>
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="newsDialogVisible02"
            title="新闻与活动"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <News02></News02>
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="newsDialogVisible03"
            title="新闻与活动"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <News03></News03>
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="medalDialogVisible"
            title="国际竞赛"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <TabVue02></TabVue02>
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="f1InSchoolsDialogVisible"
            title="国际竞赛"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <F1inSchools></F1inSchools>
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="firstRobotDialogVisible"
            title="国际竞赛"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <FIRSTRobot></FIRSTRobot>
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="wroRobotDialogVisible"
            title="国际竞赛"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <WRORobot></WRORobot>
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="switchDialogVisible"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <SwitchVue></SwitchVue>
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="serviceDialogVisible"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <ServiceVue></ServiceVue>
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="schoolDialogVisible"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <SchoolVue></SchoolVue>
            <!-- <span>Open the dialog from the center from the screen</span> -->
        </el-dialog>

        <el-dialog
            class="el-dialog-container"
            v-model="contactDialogVisible"
            width="66vw"
            :append-to-body="true"
            align-center
            style="font-family: 'FangYuan'"
            destroy-on-close>
            <ContactVue></ContactVue>
            <!-- <span>Open the dialog from the center from the screen</span> -->
        </el-dialog>
    </div>
    
</template>

<script>
import ContactVue from './ContactVue.vue';
import SchoolVue from './SchoolVue.vue';
import ServiceVue from './ServiceVue.vue';
import SwitchVue from './SwitchVue.vue';
import TabVue01 from './TabVue01.vue';
import TabVue02 from './TabVue02.vue';
import News01 from './News01.vue';
import News02 from './News02.vue';
import News03 from './News03.vue';
import WRORobot from "./WRORobot.vue";
import FIRSTRobot from "./FIRSTRobot.vue";
import F1inSchools from "./F1inSchools.vue";

import { ref } from 'vue';
const componentKey = ref(0);  // 刷新导航栏

export default {
    data() {
        return {
            componentKey,
            activeIndex: '1',
            // activeIndex2: '1'
            newsDialogVisible: false,
            newsDialogVisible01: false,
            newsDialogVisible02: false,
            newsDialogVisible03: false,
            medalDialogVisible: false,
            f1InSchoolsDialogVisible: false,
            firstRobotDialogVisible: false,
            wroRobotDialogVisible: false,
            switchDialogVisible: false,
            serviceDialogVisible: false,
            schoolDialogVisible: false,
            contactDialogVisible: false,
        };
    },
    mounted() {
        window.addEventListener('load', this.refreshNav);  // 页面加载完毕后强制刷新导航栏解决溢出
        window.addEventListener('resize', this.refreshNav);  // 页面大小变化后强制刷新导航栏
        this.refreshNav();  // 控件加载完毕后强制刷新导航栏
    },
    methods: {
        refreshNav: function () {
            this.$nextTick(() => {
                componentKey.value += 1;
                setTimeout(() => {
                    componentKey.value += 1;
                }, 1000);
            });
        },
        handleSelect: function (key, keyPath) {
            console.log(key, keyPath);
            componentKey.value += 1;  // 刷新导航栏，重置焦点
        },
        openLink: function (url, target, features) {
            window.open(url, target, features)
        },
        roll: function (selector) {
            const element = document.getElementById(selector);
            const offset = 60; // 向上偏移30px
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: elementPosition - offset,
                behavior: "smooth"
            });
        },
        mounted: function () {
            this.roll()
        }
    },
    components: {
        TabVue01,
        News01,
        News02,
        News03,
        TabVue02,
        WRORobot,
        FIRSTRobot,
        F1inSchools,
        SchoolVue,
        ServiceVue,
        SwitchVue,
        ContactVue,
    },
}
</script>

<style>
.el-menu {
    font-family: 'ShuHei';
}

/* 右对齐方案 */
/* .el-menu--horizontal > .el-menu-item:nth-child(1) {
    margin-right: auto;
} */

/* 临时右对齐方案 */
.flex-grow {
    flex-grow: 0.9;
}

.Nav {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 100;
    overflow-x: auto;
    background-color: white;
}
</style>